import React, { useState } from "react";
import { DateRangePicker } from "react-date-range";
import { defaultStaticRanges } from "./defaultRanges";
import { format } from "date-fns";

import "react-date-range/dist/styles.css"; // main style file
import "react-date-range/dist/theme/default.css"; // theme css file

import "./Datepicker.css";

import PropTypes from "prop-types";

const DateRangeSelector = ({ ranges,selectedDateRange, setSelectedDateRange, handlereset,onChange, onSubmit, ...rest }) => {
     // const [selectedDateRange, setSelectedDateRange] = useState({
     //      startDate: new Date(),
     //      endDate: new Date(),
     //      key: "selection"
     // });
     const [show, setShow] = useState(false);

     function formatDateDisplay(date, defaultText) {
          if (!date) return defaultText;
          return format(date, "MM/DD/YYYY");
     }

     const handleSelect = ranges => {
          setSelectedDateRange(ranges.selection);
       
          console.log(ranges.selection);
     };

     const onClickDone = () => {
          
          console.log(selectedDateRange,'submit')
          onSubmit();
          
     };

     const onClickClear = () => {
          setSelectedDateRange({
               startDate: new Date(),
               endDate: new Date(),
               key: "selection"
          });
           handlereset();
          setShow(false);
     };

     return (
          <React.Fragment>
               <div className="shadow bg-white d-inline-block text-md">
                    <DateRangePicker
                         onChange={handleSelect}
                         showSelectionPreview={true}
                         moveRangeOnFirstSelection={false}
                         months={1}
                         ranges={[selectedDateRange]}
                         direction="horizontal"
                         staticRanges={ranges}
                    />
                       <div className="text-right w-full position-relative bg-white rdr-buttons-position mt-2 mr-4">
                         <button
                              className="btn btn-transparent text-primary  px-4 mr-2 hover:bg-gray-200 rounded"
                              onClick={() => onClickDone()}
                         >
                              APPLY
                         </button>
                         <button
                              className="btn btn-transparent text-danger rounded hover:bg-red-200 px-4 mr-2"
                              onClick={onClickClear}
                         >
                              RESET
                         </button>
                    </div>
               </div>

             
          </React.Fragment>
     );
};

DateRangeSelector.defaultProps = {
     ranges: defaultStaticRanges
};

DateRangeSelector.propTypes = {
     /**
      * On Submit
      */
     onSubmit: PropTypes.func
};

export default DateRangeSelector;
